import { UnitFieldCond } from "common/api/citajteo/dl_group/citajteo_group";
import ObjCommon from "model/common/ObjCommon";

export class DlGroup extends ObjCommon {
  slug: string = "";
  fCond: UnitFieldCond = {};

  constructor(args: Partial<DlGroup> = {}) {
    super(args?.id);

    this.slug = args?.slug ?? "";
    this.fCond = args?.fCond ?? {};
  }
}
